import { useAbmContext } from "../../../../views/abm/useAbmComponent";
import { ActionButton } from "../../../helpers";
import { EditIcon } from "../../../icons";

export const EditarConteoPublico = ({params}) => {
  const { setShowConteoPublicoActividad } = useAbmContext();

  return (
    <>
      {params?.value !== null && params?.value !== undefined 
        ? <span>{params.value}</span>
        : <span>NO CARGADO</span>
      }
      <ActionButton
        iconButton
        enabled={true}
        Icon={EditIcon}
        onClick={() => setShowConteoPublicoActividad(params)}
      />
    </>
  );
};
